import React from 'react';
import { Stack, Typography, Box } from '@mui/material';
import PublicInsightDetails from './PublicInsightDetails';

const PublicInsightDetailsPage: React.FC = () => {
  return (
    <Stack direction="column" spacing={3} sx={{ p: 3, flex: 1, display: 'flex' }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="title">Insight Details</Typography>
      </Stack>
      <Box sx={{ flex: 1 }}>
        <PublicInsightDetails />
      </Box>
    </Stack>
  );
};

export default PublicInsightDetailsPage;
